import { Button, Progress, Spin, Tooltip } from 'antd';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { Information, Location, MultiFamily, NextArrow, PrevArrow, WishList } from '../../assets/icons';
import { Images } from '../../config/images';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useScroll from '../../Hooks/useScroll';
import { PROPERTY_TYPES } from '../../utils/constant';
import { remainingDays } from '../../utils/remainingDaysCalculator';
import { toastNotify } from '../../utils/toastNotify';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import './MarketSliderCard.scss';

const MarketSliderCard = (props) => {
  const [swipStart, setSwipStart] = useState(false);
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [toolTipOpenNotYetAvailable, setToolTipOpenNotYetAvailable] = useState(false);
  const {
    images,
    id,
    notifyLoadingId,
    mouseEnter = () => {},
    mouseLeave = () => {},
    isChildrenSlide,
    mouseDownEvent = () => {},
    mouseUpEvent = () => {},
    isSecondary,
    slideParentSlide,
    isFavUpdating = false,
    multiFamilyTotalUnit,
    isBuyDisabled,
    duration,
  } = props;
  const subslider = {
    dots: true,
    infinite: true,
    speed: 500,
    loop: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeEvent: () => setSwipStart(true),
    afterChange: (e) => {
      setSwipStart(false);
    },
    nextArrow: <NextArrow verticalAlign='middle' color='#fff' />,
    prevArrow: <PrevArrow verticalAlign='middle' color='#fff' />,
  };
  const userProfileData = useSelector((state) => state.userData.userData);
  const loading = useSelector((state) => state.notifyMeSlice.loading);
  const location = useLocation();
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
  const screenMD = useMediaQuery('(min-width: 1000px)');
  useScroll('.share-hold');

  const handleCardClick = () => {
    if (!slideParentSlide) {
      if (!isSecondary) {
        navigate(`/property/${PROPERTY_TYPES.INITIAL}/${id}`, { state: { prevPath: location.pathname } });
      } else {
        navigate(`/property/${PROPERTY_TYPES.SECONDARY}/${id}`, { state: { prevPath: location.pathname } });
      }
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (Object.keys(userData?.userData).length > 0) {
      if (userData?.userData?.isKYCVerified) {
        e.stopPropagation();
        Object.keys(userProfileData).length > 0 ? props.BtnClick() : navigate('/login');
      } else {
        e.stopPropagation();
        !userData?.userData?.isKYCVerified
          ? toastNotify('error', 'Please complete all your verification steps first.')
          : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.');
      }
    } else {
      navigate('/login');
    }
  };

  const handleNotifyMeButtonClicked = (e) => {
    e.stopPropagation();
    props.notifyMeBtnClick({ id, isSecondary });
  };

  const handleDivToolTipOpen = (e) => {
    e.stopPropagation();
    setToolTipOpen(!toolTipOpen);
  };

  const handleNotYetAvailableToolTipOpen = (e) => {
    e.stopPropagation();
    setToolTipOpenNotYetAvailable(!toolTipOpenNotYetAvailable);
  };

  return (
    <div className='m-slider-block'>
      <div className='m-slider-block__top'>
        <div className='inner-slider'>
          <div>
            {images?.length > 0 ? (
              <div>
                <Slider {...subslider} className='subslider'>
                  {images
                    .slice(0, images.length - 1)
                    .filter((img) => img)
                    .map((item, index) => {
                      return (
                        <div
                          onMouseDown={() => mouseDownEvent()}
                          onMouseUp={() => {
                            !swipStart && handleCardClick();
                            mouseUpEvent();
                          }}
                          onMouseEnter={() => isChildrenSlide && mouseEnter()}
                          onMouseLeave={() => mouseLeave()}
                          key={index}
                        >
                          <LazyLoadImage
                            onError={(element) => {
                              element.target.src = Images.noPropertyFoundImage;
                            }}
                            src={item}
                            alt='the-leonardo'
                            effect='blur'
                          />
                        </div>
                      );
                    })}
                </Slider>
              </div>
            ) : (
              <div>
                <Slider {...subslider} className='subslider'>
                  <div
                    onMouseDown={() => mouseDownEvent()}
                    onMouseUp={() => {
                      !swipStart && handleCardClick();
                      mouseUpEvent();
                    }}
                    onMouseEnter={() => isChildrenSlide && mouseEnter()}
                    onMouseLeave={() => mouseLeave()}
                  >
                    <LazyLoadImage effect='blur' src={Images.noPropertyFoundImage} alt='the-leonardo' />
                  </div>
                </Slider>
              </div>
            )}
            {props.PrimaryButtonBuy && (
              <>
                {remainingDays(duration) >= 0 || !duration ? (
                  <Button
                    type='primary'
                    className='desktop-hide'
                    loading={props?.isFetchingUserAccount}
                    disabled={isBuyDisabled}
                    onClick={() => {
                      Object.keys(userProfileData).length > 0 ? props.BtnClick() : navigate('/login');
                    }}
                  >
                    {props.PrimaryButtonBuy}
                  </Button>
                ) : (
                  <span className='text-error fz-14 desktop-hide'>This property has been expired.</span>
                )}
              </>
            )}
            {props.GhostNotify && (
              <Button className='desktop-hide' onClick={() => props.notifyMeBtnClick({ id, isSecondary })}>
                {props.GhostNotify}
              </Button>
            )}
          </div>
        </div>
        {!!props.label && <label className={props.label}>{props.label}</label>}
        <span className='wishlist'>
          <Spin spinning={isFavUpdating}>
            <WishList verticalAlign='middle' fill={props?.isFavorite ? '#F68721' : 'rgba(26, 21, 25, 0.4)'} onClick={props.onFavoriteClick} />
          </Spin>
        </span>
      </div>
      <div onClick={handleCardClick} className='m-slider-block__bottom cursor-pointer'>
        {props.showType && <span className='block-offer'>{props.cardType}</span>}
        <h4 className='block-head'>{props.MarketBlockHead}</h4>
        {isSecondary ? (
          <div className={props.Bids ? 'share-hold secondary' : 'share-hold secondary disabled'}>
            <div className='share-hold__list'>
              <span>{props.LastPriceLabel}</span>
              <p>{props.LastPrice}</p>
            </div>
            <div className='share-hold__list'>
              <span>{props.AllTimeLabel}</span>
              <p>{props.AllTime}</p>
            </div>
            <div className='share-hold__list'>
              <span>
                {props.ShareDivLable}
                {props.ShareDivTooltip && (
                  <Tooltip
                    open={toolTipOpen}
                    onMouseEnter={() => screenMD && setToolTipOpen(true)}
                    onMouseLeave={() => screenMD && setToolTipOpen(false)}
                    onClick={handleDivToolTipOpen}
                    title={props.ShareDivTooltip}
                    trigger='hover'
                  >
                    <span className='info-popover'>
                      <Information verticalAlign='-3px' color='#726460' />
                    </span>
                  </Tooltip>
                )}
              </span>
              <p>{props.ShareDivValue}</p>
            </div>
          </div>
        ) : (
          <div className='share-hold'>
            <div className='share-hold__list'>
              <span>{props.RemainShareLable}</span>
              <p>{getUsCurrencyFormatWithoutDecimal(props.RemainShares)}</p>
            </div>
            <div className='share-hold__list'>
              {/* Comment out for CR change to hide investor count */}
              {/* <span>{props.ShareInvestorLabel}</span>
              <p>{getUsCurrencyFormatWithoutDecimal(props.ShareInvestor)}</p> */}
            </div>
            <div className='share-hold__list'>
              <span>{props.MinimumnSharesLabel}</span>
              <p>{`$ ${getUsCurrencyFormat(Number(props.MinimumnShares.split('$')[1]))}`}</p>
            </div>
          </div>
        )}

        {isSecondary ? (
          <div className='share-hold__list share-hold__list--activity'>
            <span>Activity</span>
            {props?.Bids || props?.Asks ? (
              <p>
                {props.Bids} Bids <span className='text-taupe-40 fz-32 px-8'> • </span> {props.Asks ? `${props.Asks}` : '0'} Asks
              </p>
            ) : (
              <p>
                Not Yet Available{' '}
                <Tooltip
                  open={toolTipOpenNotYetAvailable}
                  onMouseEnter={() => screenMD && setToolTipOpenNotYetAvailable(true)}
                  onMouseLeave={() => screenMD && setToolTipOpenNotYetAvailable(false)}
                  onClick={handleNotYetAvailableToolTipOpen}
                  title={props.NotAvailableTooltip}
                  trigger='hover'
                >
                  <span>
                    <Information color='#726460' />
                  </span>
                </Tooltip>
              </p>
            )}
          </div>
        ) : (
          <div
            className={`progressbar ${props.ProgressPercent > 0 && 'progressbar--copper'} ${props.ProgressPercent === 100 && 'progressbar--success'}`}
          >
            {props.ProgressPercent && <Progress percent={props.ProgressPercent} format={(percent) => `${percent}% funded`} />}
          </div>
        )}

        <ul className='location'>
          <li>
            <Location className='icon' verticalAlign='middle' />
            <span className='city'>{props.LocationProperty}</span>
          </li>
          <li className='propertyTypeImage'>
            {!props?.propertyTypeImage ? (
              <MultiFamily className='icon' verticalAlign='middle' />
            ) : (
              <LazyLoadImage effect='blur' src={props?.propertyTypeImage} alt={props?.propertyType} width={24} className='inline-flex icon' />
            )}
            <span className='location__name'>
              {props.propertyType}
              {props?.propertyType === 'Multifamily' && multiFamilyTotalUnit !== null && (
                <>
                  <span className='ml-4 mr-4 text-taupe-60'>•</span>
                  <span>{multiFamilyTotalUnit > 1 ? multiFamilyTotalUnit + ' Units' : multiFamilyTotalUnit + ' Unit'}</span>
                </>
              )}
            </span>
          </li>
          {props.PrimaryButtonBuy && (
            <>
              {remainingDays(duration) >= 0 || !duration ? (
                <Button
                  type='primary'
                  disabled={isBuyDisabled}
                  className='mobile-hide'
                  onClick={handleButtonClick}
                  loading={props?.isFetchingUserAccount}
                >
                  {props.PrimaryButtonBuy}
                </Button>
              ) : (
                <span className='text-error fz-14 mobile-hide'>This property has been expired.</span>
              )}
            </>
          )}
          {props.GhostNotify && (
            <Button className='mobile-hide' onClick={handleNotifyMeButtonClicked} loading={notifyLoadingId === id && loading}>
              {props.GhostNotify}
            </Button>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MarketSliderCard;
